import type { TFunction } from "i18next";
import { ActivityStatus } from "../../../core/dtos/ActivityStatus";

export const getLabelFromStatus = (
    status: ActivityStatus,
    t: TFunction,
    count?: number,
): string => {
    const variant = count && count > 0 ? "plural" : "singular";
    switch (status) {
        case ActivityStatus.LINKED:
            return t(`entity.fulfilment.activity.status.linked.${variant}`);
        case ActivityStatus.PENDING:
            return t("entity.fulfilment.activity.status.pending");
        case ActivityStatus.CLOSED:
            return t(`entity.fulfilment.activity.status.closed.${variant}`);
        case ActivityStatus.COMPLETED:
            return t(`entity.fulfilment.activity.status.completed.${variant}`);
        default:
            return "";
    }
};
